import { useState } from "react";

export const useSpeechRecognition = () => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");

  const startListening = (onResult, onStateChange) => {
    if (!("webkitSpeechRecognition" in window)) {
      console.error("Speech recognition not supported");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.continuous = true;
    recognition.lang = "en-US";

    setIsListening(true);
    onStateChange?.("আমি শুনছি। এই ইংরেজি শব্দটি উচ্চারণ করুন।");

    recognition.start();

    const timeout = setTimeout(() => {
      setIsListening(false);
      recognition.stop();
      onStateChange?.("আপনার উত্তরের জন্য অপেক্ষা করছি");
    }, 5000);

    recognition.onresult = (event) => {
      clearTimeout(timeout);
      setIsListening(false);
      onStateChange?.("আপনার উত্তরের জন্য অপেক্ষা করছি");

      const newTranscript =
        event.results[event.results.length - 1][0].transcript;
      setTranscript(newTranscript);
      onResult?.(newTranscript);
    };

    recognition.onerror = () => {
      clearTimeout(timeout);
      setIsListening(false);
      onStateChange?.("আপনার উত্তরের জন্য অপেক্ষা করছি");
    };
  };

  return {
    isListening,
    transcript,
    startListening,
    setTranscript,
  };
};
